module.exports = require("has-content");;